module.exports = __webpack_public_path__ + "img/hugh-francis-2022.9ca28c16.jpg";